export const sortByToLower = (option) => {
  return option?.name?.toLowerCase();
};

export function getFilteredByText(options, filterByText) {
  return options?.filter((option) => option?.name?.toLowerCase().includes(filterByText?.toLowerCase()));
}
